import * as apiClient from './client'

apiClient.client.interceptors.response.use(async (response) => {
  if (response.status >= 400) {
    const data = await response.json()
    throw Object.assign(new Error(data.message || data.detail), { status: response.status })
  }
  return response
})

export { apiClient }
